import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultInquiryFormsContent: PageTypeContentModule = {
  pageTypeSlug: "inquiry-forms",
  suggestedTitles: ["Contact Form", "Get a Quote", "Request Information", "Submit Inquiry"],
  suggestedSlugs: ["contact-form", "get-quote", "request-info", "inquiry"],
  description: "Inquiry forms and contact request pages",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Get In Touch", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "We'd love to hear from you. Please fill out the form below and our team will get back to you as soon as possible.",
        },
      },
      {
        type: "header",
        data: { text: "What Would You Like To Know?", level: 2 },
      },
      {
        type: "list",
        data: {
          style: "unordered",
          items: [
            "Product information and specifications",
            "Pricing and quotes",
            "Custom solutions and bulk orders",
            "Partnership opportunities",
            "General inquiries",
          ],
        },
      },
      {
        type: "header",
        data: { text: "Response Time", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Our team typically responds to all inquiries within 24-48 business hours. For urgent matters, please call us directly.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
